import { ISingleIdParams } from '../types/actionParams';
import { IResult } from '../types/IResponse';
import { Request } from './Request';

// NOTE: This request violates the standard contract;
// rather than returning an IResult, it returns a boolean.
// The existing uses check the "truthiness" of the result.
// The API should be changed to adhere to the standard contract.
export class TestOAuthCredentialRequest extends Request<ISingleIdParams, IResult> {
  constructor(id: string) {
    super('testOAuthCredential', { id: id });
  }
}
